export default "__VITE_ASSET__CqivB2Mt__"